/* eslint-disable react-refresh/only-export-components */
import { ComponentType } from 'react';
import { PanelFeatureEnum, PointOfInterest } from '@/__generated__/graphql';
import { AllPointOfInterestTemplate } from '@/types';
import { useBlisterData } from '../../hooks/useBlisterData';
import { UseTemplateFieldsHookType } from '../../hooks/useTemplateFields';
import { ManualHeightField, MarkAsPitCheckbox } from '../BlisterFormParts';

export type BlisterDataHookType = ReturnType<typeof useBlisterData>;

export type EditFeatureProps = {
  poi: Partial<PointOfInterest>;
  template: AllPointOfInterestTemplate[0] | undefined;
  templateDataHook: UseTemplateFieldsHookType;
  blisterDataHook: BlisterDataHookType;
};

const ManualSetHeightFeature = ({ blisterDataHook }: EditFeatureProps) => (
  <ManualHeightField
    manualSetHeight={blisterDataHook.blisterFieldsData?.manualSetHeight}
    handleManualHeightChange={blisterDataHook.handleManualHeightChange}
    handleMeasureIconClick={blisterDataHook.handleMeasureIconClick}
  />
);

const MarkAsPitFeature = ({ blisterDataHook }: EditFeatureProps) => {
  const hasBlisterHeight = Boolean(blisterDataHook.blisterFieldsData?.estimatedHeight);
  if (!hasBlisterHeight) return null;
  return <MarkAsPitCheckbox />;
};

export const editPanelFeatureRegistry: Partial<
  Record<PanelFeatureEnum, ComponentType<EditFeatureProps>>
> = {
  [PanelFeatureEnum.ManualSetHeight]: ManualSetHeightFeature,
  [PanelFeatureEnum.MarkAsPit]: MarkAsPitFeature,
};
